export default __webpack_public_path__ + "static/contact-img-5a0a1a1de5d497f3b4b804c7c5983de0.png";